// de_pms_groups.ts
// Tłumaczenia dla PMS.Groups.tsx

export const dePmsGroups = {

  title:       "Gruppen und Veranstaltungen",
  description: "Operative Uebersicht von Gruppenreservierungen und verknuepften Veranstaltungen.",
  filters:     "Filter",
  filtersHint: "Schraenke Gruppenreservierungen mit vielen Veranstaltungen schnell ein.",
  none:        "Keine",

} as const;

export default dePmsGroups;
